// Imports
import { Content, Img } from "@/components";

export function Menu({ items }) {
  if (!items || items.length === 0) {
    return null;
  }
  return (
    <div className="w-full pt-12">
      <h3 className="pb-4 level-2">Menu</h3>
      <div className="grid gap-4">
        {items.map((item, index) => (
          <div
            key={index}
            className="flex flex-row p-5 space-x-4 border shadow-lg lg:space-x-8 bg-card lg:p-7 rounded-base text-card-foreground"
          >
            {item?.image && (
              <div>
                <div className="relative w-20 h-20 overflow-hidden aspect-square lg:w-40 lg:h-40 bg-light-grey rounded-card-radius">
                  <Img
                    className="object-cover w-full h-full aspect-square"
                    sizes="250px"
                    data={item.image}
                  />
                </div>
              </div>
            )}

            <div className="flex flex-col justify-between h-full">
              <div>
                <h3 className="level-3">{item.name}</h3>
                <Content content={item.description_content} />
              </div>
              <h2 className="level-3">${item?.price}</h2>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
